import { useEffect, useRef } from 'react'

import { trackStudioEvent } from 'Pods/ThreeDStudio/Services/studioTracker'

// Fires a page-view GTMevent once per mount. Callers gate `enabled` on
// pageConfigLoaded: the gtm_user_data_load push carrying user_id comes from
// /load-services.js, and our event must enter the dataLayer queue after it or
// GA4 receives the page view without user_id.
export default function useStudioPageViewEvent(eventName, { enabled = true } = {}) {
  const hasFiredRef = useRef(false)

  useEffect(() => {
    if (!enabled || hasFiredRef.current) return
    hasFiredRef.current = true
    trackStudioEvent(eventName)
  }, [enabled, eventName])
}
